import React from "react";
import { getSourceImageUrlToCGI } from "../../utils/base";
import { Link } from "../../utils/customLink";

const BlogFancyCtaBlock = ({ post }) => {
  const ctaImageMain =
    getSourceImageUrlToCGI({ uri: post?.blogFancyCtaImageMain?.sourceUrl }) ??
    "";
  const ctaImageInset =
    getSourceImageUrlToCGI({ uri: post?.blogFancyCtaImageInsert?.sourceUrl }) ??
    "";
  const ctaTitle = post?.blogFancyCtaTitle ?? "";
  const ctaSummary = post?.blogFancyCtaSummary ?? "";
  const ctaButtonTitle = post?.blogFancyCtaButtonTitle ?? "";
  const ctaButtonLink = post?.blogFancyCtaButtonLink ?? "#";

  return (
    <section className="relative sm:py-[6.5rem]">
      <div className="flex flex-col-reverse items-center justify-between w-11/12 mx-auto sm:w-10/12 sm:flex-row">
        <div className="w-full sm:w-1/2">
          <p className="font-heading font-medium text-[14px] leading-[0%] tracking-[0.19em] text-black-lighter  uppercase">
            {ctaTitle}
          </p>
          <div className="border-l-[6px] sm:px-8 px-2 sm:mt-8  border-yellow-lighten">
            <h1
              className="font-normal font-body   leading-[31px] sm:leading-[46px]  text-black-lighter"
              dangerouslySetInnerHTML={{ __html: ctaSummary }}
            />
            <Link
              className="flex items-center justify-center w-full h-10 gap-2 px-4 mt-10 text-base font-bold leading-7 tracking-wider bg-transparent border rounded-full sm:w-max text-black-lighter   border-black-lighter "
              to={ctaButtonLink}
            >
              <span>{ctaButtonTitle}</span>
            </Link>
          </div>
        </div>
        <div className="flex justify-end w-full sm:w-1/2 sm:justify-start">
          <div
            className="relative  sm:w-[25vw] sm:h-[25vw] w-[50vw] h-[50vw] bg-cover bg-center rounded-full"
            style={{ backgroundImage: `url(${ctaImageMain})` }}
          >
            <div
              className="absolute -top-8 -left-4 sm:w-40 sm:h-40 w-[24vw] h-[24vw] bg-cover bg-center rounded-full"
              style={{ backgroundImage: `url(${ctaImageInset})` }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogFancyCtaBlock;
